import gql from 'graphql-tag'

export const UPDATE_FREELANCER = gql`
  mutation update($input: UpdateFreelancerInput!) {
    updateFreelancer(input: $input) {
      globalId
      name
    }
  }
`

export const UPDATE_USER = gql`
  mutation update($input: UpdateUserInput!) {
    updateUser(input: $input) {
      globalId
      name
    }
  }
`

export const UPDATE_ACCOUNT = gql`
  mutation update($input: UpdateAccountInput!) {
    updateAccount(input: $input) {
      globalId
      name
    }
  }
`

export const UPDATE_COMPANY = gql`
  mutation update($input: UpdateCompanyInput!) {
    updateCompany(input: $input) {
      globalId
      name
    }
  }
`
